import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';
import { getSelectMessage } from '../../../utils/formValidation/errorMessageFunctions';

export const validate = (newEntry, initialState, type) => {
    let newErrors = {};

    if (!newEntry.sectorId) {
        newErrors = {
            ...newErrors,
            sectorId: { error: true, message: getSelectMessage('sector') }
        };
    }

    if (type === 'edit' && Object.keys(newErrors).length < 1)
        newErrors = checkDiff(newEntry, initialState);

    return newErrors;
};
